import { ApiParameter, get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

import { ExpediteShippingModel, ExpediteShippingOrderHistoryModel } from "@TKCCP/Types/ApiModels";

export interface ExpediteShippingParameter extends ApiParameter {
    cartId: string;
    expeditemodel: ExpediteShippingModel;
}

export interface ExpediteShippingOrderParameter extends ApiParameter {
    cartId: string;
    expediteOrderModel: ExpediteShippingOrderHistoryModel;
}

export interface GetExpediteShippingParameter extends ApiParameter {
    cartId: string;
}

export interface GetExpediteShippingOrderHistoryParameter extends ApiParameter {
    orderNumber: string;
}

const expediteUrl = "api/v1/TKCCPExpediteShipping";
const expediteOrderUrl = "api/v1/TKCCPExpediteShippingOrder";

export async function getExpediteShipping(parameter: GetExpediteShippingParameter): Promise<ExpediteShippingModel> {
    const con = await get<ExpediteShippingModel>(`api/v1/TKCCPExpediteShipping/${parameter.cartId}`);
    // eslint-disable-next-line no-console
    return con;
}

export function getExpediteShippingOrderHistory(
    parameter: GetExpediteShippingOrderHistoryParameter,
): Promise<ExpediteShippingOrderHistoryModel> {
    const con = get<ExpediteShippingOrderHistoryModel>(`${expediteOrderUrl}/${parameter.orderNumber}`);
    // eslint-disable-next-line no-console
    return con;
}

export async function addExpediteShipping(parameter: ExpediteShippingParameter) {
    const expeditemodel = parameter.expeditemodel;

    const cartId = parameter.cartId;
    expeditemodel.cartId = cartId;
    const model = await post<ExpediteShippingModel>(`${expediteUrl}/${cartId}/true`, parameter.expeditemodel);
    return model;
}

export async function addExpediteShippingOrder(parameter: ExpediteShippingOrderParameter) {
    const expediteOrderModel = parameter.expediteOrderModel;
    const cartId = parameter.cartId;
    const model = await post<ExpediteShippingOrderHistoryModel>(
        `${expediteOrderUrl}/${cartId}/true`,
        parameter.expediteOrderModel,
    );
    return model;
}
